import { c as _c } from "react/compiler-runtime";
import { type RefObject, useEffect, useRef } from 'react';
const EVENTS = ['mousedown', 'touchstart'] as const;
export default function useOnClickOutside(ref, handler) {
  const $ = _c(5);
  const handlerRef = useLatest(handler);
  let t0;
  let t1;
  if ($[0] !== handler || $[1] !== handlerRef || $[2] !== ref) {
    t0 = () => {
      if (!handler) {
        throw new Error("No handler defined");
      }
      const listener = event => {
        if (!ref.current || !handlerRef.current || event.target !== null && ref.current.contains(event.target as Node)) {
          return;
        }
        handlerRef.current(event);
      };
      EVENTS.forEach(event_0 => {
        document.addEventListener(event_0, listener);
      });
      return () => {
        EVENTS.forEach(event_1 => {
          document.removeEventListener(event_1, listener);
        });
      };
    };
    t1 = [handler, handlerRef, ref];
    $[0] = handler;
    $[1] = handlerRef;
    $[2] = ref;
    $[3] = t0;
    $[4] = t1;
  } else {
    t0 = $[3];
    t1 = $[4];
  }
  useEffect(t0, t1);
}
function useLatest(value) {
  const $ = _c(2);
  const ref = useRef(value);
  let t0;
  if ($[0] !== value) {
    t0 = () => {
      ref.current = value;
    };
    $[0] = value;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  useEffect(t0);
  return ref;
}